// Adres wsparcia — JEDNO miejsce (sesja 11, G2-auth-onboarding-04).
//
// Do 2026-09-08 stała mieszkała w `routes/OnboardingView.tsx`, a panel konta odrzuconego
// mówił „napisz do nas” bez adresu; `Billing.tsx` i `Order.tsx` miały ten sam adres
// wpisany literalnie. Cztery kopie jednej prawdy to cztery szanse, że zmiana skrzynki
// dotrze do trzech ekranów. Adres nie jest sekretem (stoi w stopce publicznej), więc
// wolno mu żyć w kodzie; sekrety mieszkają w `config.py` (inwariant 3).

export const SUPPORT_MAIL = 'kontakt@edimi.ai'
export const SUPPORT_MAILTO = `mailto:${SUPPORT_MAIL}`
